import { KanbanBoard, ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import OpportunitiesListItem from '../OpportunitiesListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="opportunitiesView" itemLayout={OpportunitiesListItem} />
	},
	{
		id: 'kanban',
		title: 'VIEW_OPPORTUNITIES_TAB_KANBAN',
		content: props => (
			<KanbanBoard id="opportunitiesKanban" module="opportunities" bucket="opportunities_statuses" />
		)
	}
];

export default tabs;
